module.exports = __webpack_public_path__ + "static/TT-Plans-Fact_Sheet-b899c512593ce7c8a6448ca1fb231ff4.jpg";